<template>
  <div>
    <BaseStepper class="my-1" :steps="steps" />

    <QuoteErrorAlert class="mx-3 mx-xl-0" :isQuotationStage="false" />

    <div class="white rounded-lg elevation-3 ma-3 pa-3 pa-lg-8">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { APPLICATION_MODULE } from "@/store/types/module-types";
import { ROUTE_NAME } from "@/constants/route.constants";
import BaseStepper from "@/components/BaseComponents/BaseStepper";
import QuoteErrorAlert from "@/components/QuoteErrorAlert.vue";

export default {
  name: "LandlordsB2BApplicationLayout",
  components: {
    BaseStepper,
    QuoteErrorAlert,
  },
  data() {
    return {
      steps: [
        {
          stepNumber: 4,
          label: "Your application",
          routeName: ROUTE_NAME.LANDLORDS.B2B.APPLICATION,
        },
        {
          stepNumber: 5,
          label: "Payment",
          routeName: ROUTE_NAME.LANDLORDS.B2B.PAYMENT,
        },
        {
          stepNumber: 6,
          label: "Complete",
          routeName: "",
        },
      ],
    };
  },
  computed: {
    ...mapState(APPLICATION_MODULE, ["paymentErrorMessage"]),
  },
};
</script>

<style lang="scss" scoped></style>
